import { render } from "./JournalList.vue?vue&type=template&id=dcad532a&ts=true"
import script from "./JournalList.vue?vue&type=script&lang=ts"
export * from "./JournalList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__